<template>

    <!-- !!!!!!!!!!!!!!!!!!!!!!!!!!!! -->
    <!-- CONSIDER USING TELEPORT IN VUE3 TO APPEND MODAL TO BODY,  -->
     <!-- REF: https://vuejs.org/api/built-in-components.html#teleport -->
    <!-- !!!!!!!!!!!!!!!!!!!!!!!!!!!! -->
    <div id="video-modal" ref="videoModal" class="modal fade" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-lg video-modal" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ video.title }}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true"><img src="~public@/images/close_btn.png" width="24" height="24" /></span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="embed-responsive embed-responsive-16by9">
                        <iframe id="video-iframe" class="embed-responsive-item" :src="url" allowfullscreen></iframe>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    @import "../../../sass/layout/video-modal";
</style>

<script>
    import { mapState } from 'pinia';
    import { useMaterialsStore } from './store.js';


    export default {
        props: ['modelValue'],

        data() {
            return {
            }
        },
        computed: {
            url: function(){
                if (this.video.url) {
                    return 'https://www.youtube.com/embed/'+this.video.url.split('v=')[1]+'?ecver=2&modestbranding=1&autoplay=0&showinfo=0&enablejsapi=1&rel=0';
                }
                if (this.video.assessmentURL) {
                    return this.video.assessmentURL
                }
            },
            ...mapState(useMaterialsStore, ['video'])
        },
        methods: {
            stopVideo() {
                document.getElementById('video-iframe').contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');
            },
            hiddenHandler() {
                this.$emit('update:modelValue', false);
            },
        },
        mounted() {
            useMaterialsStore();
            $('#video-modal').on('hidden.bs.modal', e => this.stopVideo());
        }
    }
</script>
